import { type AddToCartHookProps } from "~/features/addToCart/hooks/useAddToCartForm";
import type { CloseIntent } from "~/features/addToCart/flow/useAtcFlowController";
import {
  AtcWizardProviders,
  type AddToCartSubmitHandler,
  useAtcWizardProcess,
} from "~/features/addToCart/components/AddToCartProcess/AddToCartWizardShared";
import { AtcWizardScreens } from "~/features/addToCart/components/AddToCartProcess/AtcWizardScreens";
import { resolveEditPartScreen } from "~/features/addToCart/flow/resolveEditPartScreen";

export interface AddToCartWizardProps extends AddToCartHookProps {
  restrictionQuery: string;
  onRequestClose: (intent: CloseIntent) => void;
  onSubmit: AddToCartSubmitHandler;
}

export const EditPartWizard = ({ restrictionQuery, onRequestClose, onSubmit, ...hookProps }: AddToCartWizardProps) => {
  const process = useAtcWizardProcess({
    flowKind: "editPart",
    hookProps,
    onRequestClose,
    onSubmit,
    resolveScreen: resolveEditPartScreen,
    restrictionQuery,
  });

  return (
    <AtcWizardProviders derivedCtx={process.derivedCtx} flowContextProps={process.flowContextProps} form={process.form}>
      <AtcWizardScreens
        canSeeAddToCartDisclaimer={process.canSeeAddToCartDisclaimer}
        canSubmitToCartOrQuote={process.canSubmitToCartOrQuote}
        flowKind="editPart"
        isSending={process.isSending}
        productDescriptor={process.productDescriptor}
        screen={process.currentScreen}
        submit={process.submit}
      />
    </AtcWizardProviders>
  );
};
